import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, Observable, tap, throwError } from "rxjs";
import { FolhaPagamento } from "../models/folhaPagamento.model";

@Injectable({
    providedIn: 'root',
})
export class FolhaPagamentosService {
    private apiUrl = `${environment.advContabilApi}/api/folhaSalario`;
    private readonly listarFolhaPagamentos = `${this.apiUrl}/Listar/`;
    private readonly deletarFolhaPagamentos = `${this.apiUrl}/Deletar/`;
    private readonly atualizarPagamento = `${this.apiUrl}/Atualizar/`;
    private readonly inserirPagamento = `${this.apiUrl}/Inserir/`;

    constructor(private http: HttpClient) {
    }

    getFolhaPagamentos(usuarioId: string): Observable<FolhaPagamento[]> {
        const params = new HttpParams().set('usuarioId', usuarioId);
        return this.http.get<FolhaPagamento[]>(`${this.listarFolhaPagamentos}`, { params });
    }

    addContaContabil(pagamento: any): Observable<any> {
        return this.http.post<any>(this.inserirPagamento, pagamento);
    }

    updatePlanoDeContas(id: string, pagamento: FolhaPagamento): Observable<any> {
        return this.http.put<any>(`${this.atualizarPagamento}${id}`, pagamento).pipe(
            tap((resposta) => {
            }),
            catchError((error) => {
                console.error('Erro ao editar pagamento', error);
                return throwError(() => new Error('Falha ao editar pagamento'));
            })
        );
    }

    deletePagamento(id: any): Observable<any> {
        return this.http.delete<any>(`${this.deletarFolhaPagamentos}${id}`).pipe(
            tap((resposta) => {
            }),
            catchError((error) => {
                console.error('Erro ao deletar pagamento', error);
                return throwError(() => new Error('Falha ao deletar pagamento'));
            })
        );
    }
}
